export default "__VITE_ASSET__24syhIJU__"